<template>
  <div
      class="playlist-item"
      draggable="true"
      @dragstart="onDragStart"
      @dragend="$emit('drag-end')"
      @dragover="$emit('drag-over', $event)"
      @drop="$emit('drop', $event, index, item.fileEntryId)"
  >
    <div class="drag-handle">
      <i class="fas fa-grip-vertical"></i>
    </div>
    <div class="item-number">{{ index + 1 }}</div>
    <div class="item-thumbnail">
      <img
          v-if="thumbnailUrl"
          :src="thumbnailUrl"
          :alt="fileTitle"
          loading="lazy"
      />
      <i v-else class="fas fa-video"></i>
    </div>
    <div class="item-info">
      <div class="item-title">{{ fileTitle }}</div>
      <div class="item-meta">
        <span>{{ fileSize }}</span>
        <span>{{ fileDate }}</span>
      </div>
    </div>
    <div class="item-actions">
      <b-button
          size="sm"
          variant="outline-danger"
          @click="$emit('remove', { playlistId, fileEntryId: item.fileEntryId })"
          title="حذف از پلی‌لیست"
      >
        <feather-icon icon="TrashIcon"></feather-icon>
        <i class="fas fa-times"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import {BButton} from 'bootstrap-vue'
import Helper from '@/libs/Helper'

export default {
  name: 'PlaylistItem',
  components: { BButton },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    playlistId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      baseUrl: Helper.baseUrl || 'https://demoapi.lenzava.com'
    }
  },
  computed: {
    fileEntry() {
      return this.item.fileEntry || {}
    },
    fileTitle() {
      return this.fileEntry.title || 'بدون عنوان'
    },
    thumbnailUrl() {
      const file = this.fileEntry
      if (!file) return null
      if (file.thumbnailUrl) {
        const url = file.thumbnailUrl
        if (url.startsWith('http://') || url.startsWith('https://')) return url
        const cleanUrl = url.startsWith('/') ? url.substring(1) : url
        return `${this.baseUrl}/${cleanUrl}`
      }
      // Try to find thumbnail from variants
      if (file.variants && Array.isArray(file.variants)) {
        const thumbVariant = file.variants.find(v => v.variantType === 'THUMBNAIL')
        if (thumbVariant) {
          const path = thumbVariant.path
          if (path.startsWith('http://') || path.startsWith('https://')) return path
          const cleanPath = path.startsWith('/') ? path.substring(1) : path
          return `${this.baseUrl}/${cleanPath}`
        }
      }
      return null
    },
    fileSize() {
      const size = this.fileEntry.size || 0
      if (size === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(size) / Math.log(k))
      return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    fileDate() {
      const date = this.fileEntry.createdAt
      if (!date) return '—'
      const d = new Date(date)
      return d.toLocaleDateString('fa-IR')
    }
  },
  methods: {
    onDragStart(event) {
      this.$emit('drag-start', event, this.index, this.item.fileEntryId)
    }
  }
}
</script>

<style scoped>
.playlist-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 14px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  cursor: grab;
}
.playlist-item:hover {
  background: #f1f5f9;
  border-color: #6366f1;
}
.playlist-item:active {
  cursor: grabbing;
}
.drag-handle {
  color: #94a3b8;
  cursor: grab;
  padding: 4px;
  font-size: 14px;
  flex-shrink: 0;
}
.item-number {
  font-weight: 700;
  color: #94a3b8;
  font-size: 14px;
  min-width: 28px;
  text-align: center;
  flex-shrink: 0;
}
.item-thumbnail {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #64748b;
  flex-shrink: 0;
  overflow: hidden;
}
.item-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.item-info {
  flex: 1;
  min-width: 0;
}
.item-title {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-meta {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #94a3b8;
}
.item-actions {
  flex-shrink: 0;
}
.item-actions .btn {
  padding: 4px 8px;
  font-size: 12px;
}
</style>
